import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'
import GettingStarted from '@segment/templates/GettingStarted'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import LogoCarousel from './components/LogoCarousel'
import CustomizableSolutions from './components/CustomizableSolutions'
import Information from './components/Information'

import ogImageJpg from './assets/OgDeveloperToolkit.jpg'

const DeveloperToolkitView = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Twilio Segment and Mixpanel | Twilio Segment"
        pageDescription="Unlock key insights about your users with Twilio Segment & Mixpanel together in your tech stack. Learn how you can collect, organize, and analyze data with a powerful CDP and an analytics tool."
        pageOG={ogImageJpg}
      >
        <Navigation />
        <Hero />
        <Main>
          <LogoCarousel />
          <CustomizableSolutions />
          <Information />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main``

export default DeveloperToolkitView
